// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3jp8f","image":"Header_image__3DsOD","name":"Header_name__K75v1","info":"Header_info__2b75y","infoRow":"Header_infoRow__2e47t"};